import { render, staticRenderFns } from "./SpecialtiesDetails.vue?vue&type=template&id=12f5a874&scoped=true"
import script from "./SpecialtiesDetails.vue?vue&type=script&lang=js"
export * from "./SpecialtiesDetails.vue?vue&type=script&lang=js"
import style0 from "./SpecialtiesDetails.vue?vue&type=style&index=0&id=12f5a874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f5a874",
  null
  
)

export default component.exports